import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { teamTasksPaths } from "../../utils/teamNavigation";
import { formatTaskDisplayName } from "../../pages/TeamTasks/utils/taskDisplayName";

const RequiredTasksDialog = ({ open, onClose, pendingTasks = [], leadId }) => {
  const { t } = useTranslation("teamTasks");
  const navigate = useNavigate();
  const tasksPaths = teamTasksPaths();

  const openBoard = () => {
    if (leadId) navigate(tasksPaths.lead(leadId));
    onClose();
  };

  const openTask = (task) => {
    const boardId = task?.boardId != null ? Number(task.boardId) : null;
    const cardId = task?.id != null ? Number(task.id) : null;
    if (boardId && cardId) {
      navigate(`${tasksPaths.board(boardId)}?card=${cardId}`);
      onClose();
      return;
    }
    openBoard();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("requiredTasksTitle")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("requiredTasksBody")}
        </Typography>
        <List dense>
          {pendingTasks.map((task) => (
            <ListItem key={task.id} disablePadding>
              <ListItemButton onClick={() => openTask(task)} sx={{ borderRadius: 1 }}>
                <ListItemText
                  primary={formatTaskDisplayName(task.id, task.title)}
                  secondary={
                    task.boardName
                      ? `${task.boardName} · ${task.columnName || ""}`
                      : t("requiredTasksOpenCardHint")
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("cancel")}</Button>
        <Button variant="contained" onClick={openBoard}>
          {t("openTaskBoard")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequiredTasksDialog;
